import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { getNavigate, } from "../helper/utility";
import { SocialMediaLinkModel } from "../models/SocialMediaLinkModel";
import { SuburbModel } from "../models/SuburbModel";
import { PageModel } from '../models/PageModel';
import { BrandModel } from '../models/BrandModel';
import { VehicleTypeModel } from '../models/VehicleTypeModel';
import { StateModel } from '../models/StateModel';
import TopHeader from './TopHeader';
import MegaMenu from './MegaMenu';
import "../assets/css/Header.css";

interface HeaderProps {
    suburbs: SuburbModel[];
    socialMediaLink: SocialMediaLinkModel[];
    dynamicServices: PageModel[];
    brands: BrandModel[];
    vehicleTypes: VehicleTypeModel[];
    // states: StateModel[];
}

const Header = ({
    suburbs,
    socialMediaLink,
    dynamicServices,
    brands,
    vehicleTypes,
    // states
}: HeaderProps) => {
    const navigate = getNavigate();
    const { register } = useForm();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeMenu, setActiveMenu] = useState<number | null>(null);
    return (
        <div className="custom-header">
            <TopHeader
                suburbs={suburbs}
                socialMediaLink={socialMediaLink}
                navigate={navigate}
                register={register}
                mobileMenuOpen={mobileMenuOpen}
                setMobileMenuOpen={setMobileMenuOpen}
                setActiveMenu={setActiveMenu}
            />
            <MegaMenu
                navigate={navigate}
                mobileMenuOpen={mobileMenuOpen}
                activeMenu={activeMenu}
                setActiveMenu={setActiveMenu}
                dynamicServices={dynamicServices}
                setMobileMenuOpen={setMobileMenuOpen}
                brands={brands}
                vehicleTypes={vehicleTypes}
                // states={states}
            />
        </div>
    );
};

export default Header;
